<template>
    <main-layout>
        <div class="d-flex" slot="header">
            <div class="header-left">
                <h2>{{ $t('User Roles') }}</h2>
            </div>
            <div>
                <el-button size="small" type="primary" @click="onShowAdd">{{ $t('Add Role') }}</el-button>
            </div>
        </div>

        <div class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="id" width="60" label="ID"/>
                <el-table-column prop="name" :label="$t('Name')"/>
                <el-table-column prop="identifier" :label="$t('Identifier')"/>
                <el-table-column prop="type" :label="$t('Type')"/>
                <el-table-column :label="$t('common.option')" width="80" align="right">
                    <template slot-scope="scope">
                        <a @click="onShowEdit(scope.row)">{{ $t('common.edit') }}</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <el-button size="small" type="primary" :disabled="selectionIds.length===0" @click="onDelete">
                    {{ $t('common.batch_delete') }}
                </el-button>
            </div>
        </div>

        <dialog-edit-role :role-id="role.id" v-model="showDialog"/>
    </main-layout>
</template>

<script>
import ApiService from "../utils/ApiService";
import DialogEditRole from "./DialogEditRole.vue";

export default {
    name: "UserRoles",
    components: {DialogEditRole},
    data() {
        return {
            loading: false,
            role: {},
            dataList: [],
            selectionIds: [],
            showDialog: false
        }
    },
    methods: {
        fetchList() {
            this.loading = true;
            ApiService.get('/users/roles').then(response => {
                this.dataList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        resetData() {
            this.role = {
                name: '',
                identifier: '',
                permissions: []
            };
        },
        onShowEdit(d) {
            this.role = {
                ...this.role,
                ...d
            };
            this.showDialog = true;
        },
        onShowAdd() {
            this.resetData();
            this.showDialog = true;
        },
        onDelete() {
            let ids = this.selectionIds.map((d) => d.gid);
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {

            });
        },
        onSelectionChange(val) {
            this.selectionIds = val;
        }
    },
    mounted() {
        this.fetchList();
    },
}
</script>

<style scoped>

</style>
